module.exports = __webpack_public_path__ + "static/media/catanddog.a2509581.jpg";